"use strict";

define('rs/cache',['vertebrae', 'underscore', 'backbone'], function (Vertebrae, _, Backbone) {
  function Cache(context) {
    var _cache;
    context = context || cache;
    function cache(key, fn, force) {
      if (!force && cache.has(key)) {
        return cache.get(key);
      } else {
        var value;
        if (_.isFunction(fn)) {
          value = fn.call(context, cache.get(key), force);
        } else {
          value = fn;
        }
        cache.set(key, value);
        if (value instanceof Promise) {
          return Promise.resolve(value).tap(function (v) {
            cache.set(key, v);
          });
        }
        return value;
      }
    }
    ;
    cache.has = function (key) {
      if (_cache.hasOwnProperty(key)) {
        return true;
      }
      return false;
    };
    cache.set = function (key, value) {
      var oldValue = cache.get(key);
      _cache[key] = value;
      if (!(value instanceof Promise)) {
        context.trigger('change:' + key, value, oldValue);
      }
      return this;
    };
    cache.get = function () {
      if (arguments.length > 0) {
        return _cache[arguments[0]];
      }
      return _.extend({}, _cache);
    };
    cache.clear = function () {
      if (arguments.length > 0) {
        delete _cache[arguments[0]];
      } else {
        _cache = {};
      }
      return this;
    };
    cache.clear();
    _.extend(cache, Backbone.Events);
    return cache;
  }
  ;
  return Cache;
});

